export default __webpack_public_path__ + "static/media/linkSound.de6145e3.mp3";